import {
  doc,
  setDoc,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";

export const Ledger_accounts_manager = async (data) => {
  const { accountguid, voucherid, accountsmanagerid } = data || {};

  // Validation

  if (!accountguid?.trim()) {
    return { success: false, error: "Missing accountguid" };
  }
  if (!voucherid?.trim()) {
    return { success: false, error: "Missing voucherid " };
  }
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }
  const servicetablename = "accountingfinancedb";
  try {
    // SUBCOLLECTION path
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager"
    );
    //Check duplicate accountguid inside company
    const duplicateQuery = query(
      ledgerCollection,
      where("voucherid", "==", voucherid),
      where("accountguid", "==", accountguid)
    );
    const duplicateSnap = await getDocs(duplicateQuery);
    if (!duplicateSnap.empty) {
      return { success: false, error: "accountguid already listed." };
    }
    //  GET LAST INDEXNUMBER
    // const lastIndexQuery = query(
    //   ledgerCollection,
    //   where("voucherid", "==", voucherid),
    //   orderBy("indexnumber", "desc"),
    //   limit(1)
    // );
    // const lastIndexSnap = await getDocs(lastIndexQuery);
    let indexnumber = 1;
    // if (!lastIndexSnap.empty) {
    //   const firstDoc = lastIndexSnap.docs[0];
    //   if (firstDoc) {
    //     const lastDocData = firstDoc.data();
    //     indexnumber = (lastDocData?.indexnumber || 0) + 1;
    //   }
    // }
    // Create ledger under company
    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager",
      accountsmanagerid
    );
    const savequery = {
      ...data,
      indexnumber,
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };
    await setDoc(parentDocRef, savequery);
    return { success: true };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
